  /**
   * Spoiler, vanila js
   * Робить плавне розкриття та закриття елементу. Так само як елемент "Акордеон"
   * @param {String} tagSelector - CSS селектор елемента по якому відбувється клік.
   * @param {String} contentSelector - CSS селектор елемента що повенен розкриватись та закриватися.
   */
   function handleSertificateClick({tagSelector, contentSelector}) {
    let title = document.querySelector(tagSelector) 
    let text = title.parentElement.querySelector(contentSelector) 
    
    if (!text.classList.contains('show')){
      text.style.height = 'auto';
      text.classList.add('show')
      title.classList.add('show')
      let height = text.clientHeight + 'px'
      text.style.height = '0px'
      setTimeout(() => text.style.height = height , 0);

      if (window.homeChiefSliderPromo) {
        window.homeChiefSliderPromo._config.isAutoPlay_onMouseLeave = false
        window.homeChiefSliderPromo._autoplay('stop')
      }
    } else {
      text.style.height = '0px';
      text.addEventListener(
        'transitionend', 
        () => {
          text.classList.remove('show')
          title.classList.remove('show')
        }, 
        { once: true }
      );

      if (window.homeChiefSliderPromo) {
        window.homeChiefSliderPromo._config.isAutoPlay_onMouseLeave = true
        window.homeChiefSliderPromo._autoplay();
      }
      
    }
  } 

  export default handleSertificateClick


// WEBPACK FOOTER //
// ./src/custom_js/animated_spoiler.js